import * as request from '../request';
import storage from '../storage';
import debug from '../debug';
import user from '../user';
import * as Base64 from 'js-base64';
import track from '../track';
import { getRangeNum, getRemainTime } from '../utils';
import { utils } from 'lib';

type RefreshInfo = {
  expires_in: number;
  refresh_token: string;
  access_token: string;
  refresh_date: string;
} | null;

var REFRESH_INFO = 'REFRESH_INFO_V2';
var refreshInfo: RefreshInfo = null;
var hourTimeSpan = 1000 * 60 * 60;
var ACTIONS = {
  getToken:
    'api/v3/oauth2/token?grant_type=refresh_token&refresh_token={refresh_token}&scope=PC_WEB',
};

async function init() {
  registerEvent();
  initCache();

  // if (window.inPcClient) {
  await startRefreshTimer();
  // }
  // if (MM.config.local) {
  //     refreshTimeSpan = 1000 * 60;
  // }
}

async function startRefreshTimer() {
  // setTimeout(() => {
  //   refresh('每10s刷新');
  // }, 10* 1000);

  // expires_in access_token 的过期时间
  if (refreshInfo && refreshInfo.expires_in && refreshInfo.refresh_token) {
    const timeSpan = refreshInfo.expires_in - Date.now();

    debug('refreshToken ', utils.getRemainTime(timeSpan), timeSpan);

    if (timeSpan > 1000 * 10) {
      // 每天主动刷新一次
      if (refreshInfo.refresh_date !== utils.formatTime(Date.now(), 'yyyy-MM-dd')) {
        await refresh('当天刷新一次');
      }
      // if (timeSpan < hourTimeSpan * 8) {
      //   // token 剩余时间大于 1小时 过期的，最后1小时内随机刷新
      //   refresh('8小时内初始刷新');
      // } else {
      //   setTimeout(() => {
      //     refresh('登录后到期前1分钟刷新');
      //   }, timeSpan - 1000 * 60);
      // }
    } else {
      await refresh('过期刷新');
    }
  }
}

function clear() {
  storage.remove(REFRESH_INFO);
}

function loadSecurity(security, cb) {
  if (!security) {
    cb && cb();
  }
  request.amber
    .post(`api/v1/oauth2/security/info?security=${security}`, null, {
      event: 'user',
      event_type: 'refresh_token_security',
    })
    .then((res) => {
      save(res.data);
      cb && cb(res.data.access_token);
      // loginBack();
    })
    .catch(() => {
      cb && cb();
    });
}

/**
 * 保存
 * @param {{
 *  refresh_token,
 *  expires_in,
 *  access_token
 * }} data
 */
function save(data: RefreshInfo) {
  if (data) {
    user.saveToken(data.access_token);
    if (data.expires_in > 0 && data.refresh_token) {
      const timeout = (data.expires_in - 60) * 1000;
      data.expires_in = data.expires_in * 1000 + new Date().getTime();
      // data.expires_in = new Date().getTime();
      data.refresh_date = utils.formatTime(Date.now(), 'yyyy-MM-dd');
      refreshInfo = data;
      setTimeout(() => {
        refresh('刷新后到期前1分钟刷新');
      }, timeout);
      storage.setItem(REFRESH_INFO, Base64.encode(JSON.stringify(data)));
    }
  }
}

function initCache(dataStr?: string): void {
  try {
    refreshInfo = JSON.parse(Base64.decode(dataStr || <string>storage.getItem(REFRESH_INFO)));
  } catch (e) {
    refreshInfo = null;
  }
  debug('refreshInfo:', refreshInfo, 'inPcClient', window.inPcClient);
}

var isRefresh = false;

/**
 * 通过 refresh_token 获取最新的 token
 */
async function refresh(refresh_type: string) {
  if (isRefresh) return;
  isRefresh = true;

  if (!refreshInfo || !refreshInfo.refresh_token || !refreshInfo.expires_in) {
    return;
  }
  debug('[refresh token] refresh()', refresh_type);

  return new Promise((resolve, reject) => {
    request.amber
      .post(
        `api/v3/oauth2/token?grant_type=refresh_token&refresh_token=${refreshInfo.refresh_token}&scope=PC_WEB`,
        {
          scope: 'PC_WEB',
          grant_type: 'refresh_token',
          refresh_token: refreshInfo.refresh_token,
        },
      )
      .then(function (res: any) {
        track.send({
          event: 'user',
          event_type: 'refresh_token_success',
          content: {
            refresh_type,
          },
        });
        save(res.data);
        isRefresh = false;
        resolve();
      })
      .catch(async function (res) {
        await track.send({
          event: 'user',
          event_type: 'refresh_token_error',
          content: {
            res: track.formatRes(res),
            refresh_type: refresh_type,
          },
        });
        user.expired();
        reject();
      });
  });
}

function registerEvent() {
  /**
   * storage 事件
   * @param {{
   *     key,
   *     oldValue,
   *     newValue,
   *     url,
   *     storageArea
   * }} e
   * @private
   */
  function _onstorage(e: StorageEvent) {
    if (e.key === REFRESH_INFO) {
      if (e.newValue) {
        debug('[refresh token] onstorage:', e.newValue);
        initCache(e.newValue);
        if (refreshInfo && refreshInfo.access_token) {
          track.send({
            event: 'user',
            event_type: 'refresh_token_sync_ok',
            content: {},
          });
          user.saveToken(refreshInfo.access_token);
          user.loadUserInfo(() => {});
        } else {
          track.send({
            event: 'user',
            event_type: 'refresh_token_sync_none',
            content: {},
          });
        }
      } else {
        user.logout();
        track.send({
          event: 'user',
          event_type: 'refresh_token_sync_err',
          content: {},
        });
      }
    }
  }

  if ((<any>document).attachEvent) {
    (<any>document).attachEvent('onstorage', _onstorage);
  } else {
    window.addEventListener('storage', _onstorage, false);
  }
}

function get() {
  return refreshInfo;
}

export default {
  init,
  clear,
  save,
  refresh,
  get,
  loadSecurity,
};
